var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipelineTerminal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.83 12.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e95c28;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.38,6.41v3.72c-.07,0-.13,0-.19,0-.51,0-1.02,0-1.53,0-.14,0-.22.04-.3.16-.66,1.05-1.61,1.71-2.83,1.87-1.73.23-3.09-.41-4.06-1.86-.09-.13-.17-.18-.33-.18-.5.01-1.01,0-1.51,0-.06,0-.12,0-.19,0v-3.72c.3,0,.61,0,.91,0,.26,0,.52,0,.78,0,.06,0,.14-.05.16-.1.35-.68.85-1.22,1.51-1.62.09-.06.13-.11.13-.22,0-.52,0-1.05,0-1.6-.12,0-.22,0-.33,0-.29,0-.49-.2-.5-.47,0-.27.21-.48.5-.48.54,0,1.07,0,1.61,0,.06,0,.12,0,.2,0-.01-.21.09-.43-.15-.57,0,0-.02-.02-.02-.02-.08-.09-.11-.24-.28-.2-.12.03-.25.03-.37.08-.27.1-.55,0-.64-.26-.06-.17-.02-.33.11-.46.13-.13.29-.18.47-.12.08.03.16.07.25.09.17.03.31.04.44-.14.29-.42.94-.42,1.24,0,.13.18.27.18.44.15.07-.01.15-.05.22-.08.21-.08.42-.02.55.15.12.16.11.39,0,.54-.13.17-.34.22-.55.14-.06-.02-.11-.06-.17-.07-.18-.02-.35-.06-.49.15-.1.15-.22.26-.2.47.01.13.05.15.17.15.59,0,1.17,0,1.76,0,.09,0,.18,0,.26.04.2.08.32.3.29.51-.04.22-.21.39-.44.4-.12,0-.24,0-.38,0,0,.08,0,.15,0,.21,0,.47,0,.94,0,1.41,0,.06.04.15.1.18.66.41,1.17.95,1.52,1.64.04.09.1.1.18.1.49,0,.98,0,1.48,0,.06,0,.12,0,.19,0Zm-5.45-1.39c-1.74,0-3.15,1.4-3.16,3.12,0,1.75,1.4,3.16,3.14,3.16,1.72,0,3.14-1.41,3.15-3.12,0-1.75-1.4-3.16-3.13-3.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.28,10.47v-4.33h2.96v4.33h-2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.55,6.15v4.32h-2.96v-4.32h2.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.75,10.13v-3.71c.52,0,1.02-.02,1.53,0,.3.01.53.28.53.58,0,.85,0,1.69,0,2.54,0,.3-.23.57-.52.58-.51.02-1.03,0-1.55,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m2.07,6.42v3.71c-.21,0-.4,0-.6,0-.28,0-.56,0-.85,0-.36,0-.62-.26-.62-.62,0-.83,0-1.66,0-2.49,0-.32.24-.59.55-.61.5-.02,1,0,1.52,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.76,5.48c.56,0,1.12,0,1.67,0,.23,0,.27.04.27.27,0,.27-.03.3-.27.3-1.12,0-2.23,0-3.35,0-.24,0-.25-.02-.25-.31,0-.22.03-.26.26-.26.56,0,1.12,0,1.67,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.08,11.13c-.57,0-1.14,0-1.7,0-.21,0-.24-.04-.24-.29,0-.23.04-.28.25-.28,1.12,0,2.24,0,3.36,0,.08,0,.23.04.24.08.03.13.02.28,0,.42,0,.03-.13.06-.2.07-.56,0-1.13,0-1.69,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.07,6.05c-.57,0-1.14,0-1.71,0-.2,0-.23-.04-.23-.31,0-.21.04-.26.23-.26,1.14,0,2.29,0,3.43,0,.16,0,.23.06.22.22,0,.03,0,.06,0,.08,0,.25-.02.27-.26.27-.56,0-1.12,0-1.67,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.77,11.13c-.56,0-1.13,0-1.69,0-.23,0-.25-.03-.25-.3,0-.24.03-.28.26-.28,1.12,0,2.24,0,3.37,0,.21,0,.25.05.25.29,0,.24-.03.28-.26.28-.56,0-1.12,0-1.67,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.52,5.4h-1.24v-.37h1.24v.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.24,5.04v.37h-1.24v-.37h1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.59,5.03h1.24v.37h-1.24v-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.55,5.03v.37h-1.24v-.37h1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m3.52,11.21v.37h-1.25c0-.09-.01-.18,0-.27,0-.04.07-.1.1-.1.37,0,.75,0,1.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.24,11.22v.36h-1.24v-.36h1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.83,11.22v.36h-1.25v-.36h1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.55,11.22v.36h-1.24v-.36h1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.92,10.45c-.93,0-1.55-.94-1.18-1.81.23-.55.48-1.09.72-1.63.1-.24.21-.48.32-.71.02-.05.09-.11.14-.11.03,0,.1.06.12.11.35.79.72,1.58,1.05,2.37.36.84-.26,1.78-1.17,1.78Zm-.73-1.95c-.26.28-.35.61-.22.99.13.38.4.61.79.66.37.05.68-.06.93-.38-.55.25-.95.22-1.28-.09-.32-.29-.39-.71-.23-1.18Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelineTerminal);
export default __webpack_public_path__ + "static/media/Pipeline Terminal.8fb9707d84ec8a4cf31ad1166f7d58da.svg";
export { ForwardRef as ReactComponent };